import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../utils/Envirements";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  const [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );

  const [refreshToken, setRefreshToken] = useState(() =>
    localStorage.getItem("refreshToken")
      ? JSON.parse(localStorage.getItem("refreshToken"))
      : null
  );

  const [userData, setUserData] = useState(() =>
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );

  const navigate = useNavigate();

  const loginUser = async (loginData) => {
    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: loginData.email,
          password: loginData.password
        })
      });

      const data = await response.json();

      if (response.status === 200 && data.success) {
        // Store user data
        setUserData(data?.data?.user);

        // Store access token
        setAuthTokens(data?.data?.access_token);
        localStorage.setItem("authTokens", JSON.stringify(data?.data?.access_token));

        // Store refresh token (new)
        setRefreshToken(data?.data?.refresh_token);
        localStorage.setItem("refreshToken", JSON.stringify(data?.data?.refresh_token));

        // Store user info
        localStorage.setItem("user", JSON.stringify(data?.data?.user));

        window.dispatchEvent(new Event("logged"));

        return data?.data?.user;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Login error:", error);
      return false;
    }
  };

  const refreshAccessToken = async () => {
    try {
      const storedRefreshToken = JSON.parse(localStorage.getItem("refreshToken"));

      if (!storedRefreshToken) {
        return null;
      }

      const response = await fetch(`${BASE_URL}/refresh-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          refresh_token: storedRefreshToken
        })
      });

      const data = await response.json();

      if (response.status === 200 && data.success) {
        const newAccessToken = data?.data?.access_token;

        setAuthTokens(newAccessToken);
        localStorage.setItem("authTokens", JSON.stringify(newAccessToken));

        return newAccessToken;
      } else {
        // Refresh token expired or invalid, logout user
        logoutUser();
        return null;
      }
    } catch (error) {
      console.error("Token refresh error:", error);
      logoutUser();
      return null;
    }
  };

  const logoutUser = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("authTokens"));
      const storedRefreshToken = JSON.parse(localStorage.getItem("refreshToken"));

      // Call logout endpoint to invalidate tokens on server
      if (token) {
        await fetch(`${BASE_URL}/logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `JWT ${token}`
          },
          body: JSON.stringify({
            refresh_token: storedRefreshToken
          })
        });
      }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      // Clear local storage regardless of API call success
      setAuthTokens(null);
      setRefreshToken(null);
      setUserData(null);
      localStorage.removeItem("user");
      localStorage.removeItem("authTokens");
      localStorage.removeItem("refreshToken");
      navigate('/Login');
    }
  };

  const contextData = {
    userData,
    authTokens,
    refreshToken,
    setAuthTokens,
    loginUser,
    logoutUser,
    refreshAccessToken
  };

  return (
    <AuthContext.Provider value={contextData}>
      {children}
    </AuthContext.Provider>
  );
};
